"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityValue = exports.EntityValueDefaultProps = exports.EntityValueLabelFontSizes = exports.EntityValueImageSpacing = exports.EntityValueSpacing = exports.EntityValueFontSizes = exports.EntityValueImageSizes = exports.EntityValueImagePathsSmall = exports.EntityValueImagePathsDefault = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var entity_bubble_image_1 = require("./entity-bubble-image");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var cell_header_1 = require("../elements/cell-header");
var highlighter_1 = require("../elements/highlighter");
var image_element_1 = require("../elements/image-element");
var coalesce_1 = require("../../utils/coalesce");
var lodash_1 = require("lodash");
var use_lang_1 = require("../../hooks/use-lang");
var color_bubble_1 = require("../elements/color-bubble");
var entity_menu_1 = require("./entity-menu");
var cn_1 = require("../../utils/cn");
var cls = (0, cn_1.classNames)('entity-value');
exports.EntityValueImagePathsDefault = ['banner.thumbnail', 'openGraph.image.thumbnails.large', 'openGraph.image', 'image'];
exports.EntityValueImagePathsSmall = ['openGraph.image.thumbnails.medium', 'banner.thumbnail', 'openGraph.image', 'image'];
exports.EntityValueImageSizes = {
  small: 36,
  card: 38,
  default: 48,
  smallName: 24,
  name: 32,
  title: 24,
  large: 80,
  banner: 80,
  embed: 48
};
exports.EntityValueFontSizes = {
  small: 13,
  card: 14,
  default: 15,
  name: 15,
  smallName: 13,
  title: 15,
  large: 16,
  banner: 20,
  embed: 16
};
exports.EntityValueSpacing = {
  small: 1,
  card: 1,
  default: 1,
  name: 0,
  smallName: 0,
  title: 0,
  large: 1.5,
  banner: 2,
  embed: 2
};
exports.EntityValueImageSpacing = {
  small: 2.5,
  card: 2.5,
  default: 3,
  name: 2,
  smallName: 2,
  title: 2,
  large: 3,
  banner: 3,
  embed: 2
};
exports.EntityValueLabelFontSizes = {
  small: 11,
  card: 12,
  default: 13,
  name: 15,
  smallName: 13,
  title: 15,
  large: 13,
  banner: 15,
  embed: 15
};
exports.EntityValueDefaultProps = {
  variant: 'default',
  wrap: true,
  dotSize: 6,
  space: 0.75,
  showMenu: false,
  showBadge: true,
  showName: true,
  showImage: true,
  useImageZoom: true
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    user-select: none;\n    ", "\n    \n    .shp-cell-label {\n      line-height: 1.05em;\n    }\n  "], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    user-select: none;\n    ", "\n    \n    .shp-cell-label {\n      line-height: 1.05em;\n    }\n  "])), function (_a) {
    var variant = _a.variant;
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      font-size: ", ";\n    "], ["\n      font-size: ", ";\n    "])), theme_1.theme.FONT_SIZE(exports.EntityValueFontSizes[variant]));
  }),
  desktop: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    button.ellipsis-button {\n      visibility: hidden;\n    }\n\n    &:hover button.ellipsis-button {\n      visibility: visible;\n    }\n  "], ["\n    button.ellipsis-button {\n      visibility: hidden;\n    }\n\n    &:hover button.ellipsis-button {\n      visibility: visible;\n    }\n  "])))
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", "\n\n    ", "\n  "], ["\n    ", "\n\n    ", "\n  "])), function (_a) {
    var variant = _a.variant;
    return (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      font-size: ", "em;\n\n      ", "\n\n      .shp-cell-label {\n        font-size: 1em;\n      }\n\n      .shp-badge {\n        margin-top: -2px;\n      }\n    "], ["\n      font-size: ", "em;\n\n      ", "\n\n      .shp-cell-label {\n        font-size: 1em;\n      }\n\n      .shp-badge {\n        margin-top: -2px;\n      }\n    "])), exports.EntityValueLabelFontSizes[variant] / exports.EntityValueFontSizes[variant], function (props) {
      return props.hasName && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        margin-bottom: ", ";\n      "], ["\n        margin-bottom: ", ";\n      "])), theme_1.theme.UNIT(exports.EntityValueSpacing[variant]));
    });
  }, function (_a) {
    var showNameFirst = _a.showNameFirst;
    return showNameFirst && (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      order: 2;\n      margin-top: ", ";\n      margin-bottom: 2px;\n\n    "], ["\n      order: 2;\n      margin-top: ", ";\n      margin-bottom: 2px;\n\n    "])), theme_1.theme.UNIT(2));
  })
});
var NameStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    margin: 0;\n    font-size: 1em;\n    font-weight: 500;\n    padding: 0;\n    display: flex;\n    align-items: center;\n    line-height: 1.15em;\n    text-align: left;\n    word-break: break-word;\n    ", "\n  "], ["\n    margin: 0;\n    font-size: 1em;\n    font-weight: 500;\n    padding: 0;\n    display: flex;\n    align-items: center;\n    line-height: 1.15em;\n    text-align: left;\n    word-break: break-word;\n    ", "\n  "])), function (props) {
    return !props._wrap && (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      flex-wrap: nowrap;\n    "], ["\n      flex-wrap: nowrap;\n    "])));
  })
});
var LabelAndNameStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n\n    ", "\n  "], ["\n    display: flex;\n    flex-direction: column;\n\n    ", "\n  "])), function (props) {
    return (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      margin-left: ", ";\n    "], ["\n      margin-left: ", ";\n    "])), theme_1.theme.UNIT(props.imageSpacing));
  })
});
var ImageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var BannerImageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    margin-right: ", ";\n    object-fit: contain;\n    outline: 1px solid ", ";\n\n    ", "\n  "], ["\n    margin-right: ", ";\n    object-fit: contain;\n    outline: 1px solid ", ";\n\n    ", "\n  "])), theme_1.theme.UNIT(1), theme_1.theme.COLOR('line-semi-subtle'), function (_a) {
    var _height = _a._height;
    return (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n      height: ", "px;\n      max-width: 75px;\n    "], ["\n      height: ", "px;\n      max-width: 75px;\n    "])), _height);
  })
});
var SubtitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    ", ";\n    font-weight: 400;\n    order: 5;\n    ", "\n  "], ["\n    ", ";\n    font-weight: 400;\n    order: 5;\n    ", "\n  "])), NameStyles, function (_a) {
    var variant = _a.variant;
    return (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n      margin-top: ", ";\n    "], ["\n      margin-top: ", ";\n    "])), theme_1.theme.UNIT(exports.EntityValueSpacing[variant]));
  })
});
var MenuButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    margin-left: ", ";\n  "], ["\n    margin-left: ", ";\n  "])), theme_1.theme.UNIT(2))
});
var ColorBubbleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    flex-shrink: 0;\n  "], ["\n    flex-shrink: 0;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Image: (0, styled_components_1.default)(entity_bubble_image_1.EntityBubbleImage)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  ColorBubble: (0, styled_components_1.default)(color_bubble_1.ColorBubble)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), ColorBubbleStyles),
  BannerImage: (0, styled_components_1.default)(image_element_1.ImageElement)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), BannerImageStyles),
  LabelAndName: styled_components_1.default.div(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), LabelAndNameStyles),
  Label: (0, styled_components_1.default)(cell_header_1.CellHeader)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Name: styled_components_1.default.h2(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), NameStyles),
  Subtitle: styled_components_1.default.h4(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), SubtitleStyles)
};
var EntityValue = function (props) {
  var className = props.className,
    entity = props.entity,
    menuEntity = props.menuEntity,
    variant = props.variant,
    showName = props.showName,
    showBadge = props.showBadge,
    showNameFirst = props.showNameFirst,
    useImageZoom = props.useImageZoom,
    imageInset = props.imageInset,
    highlight = props.highlight,
    alwaysShowIcon = props.alwaysShowIcon,
    showImage = props.showImage,
    label = props.label,
    subtitle = props.subtitle,
    wrap = props.wrap,
    imageStyle = props.imageStyle,
    showMenu = props.showMenu,
    onClick = props.onClick,
    menuButtonProps = __rest(props, ["className", "entity", "menuEntity", "variant", "showName", "showBadge", "showNameFirst", "useImageZoom", "imageInset", "highlight", "alwaysShowIcon", "showImage", "label", "subtitle", "wrap", "imageStyle", "showMenu", "onClick"]);
  var defn = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var badge = entity.badge || props.badge || entity.builtIn && 'Built-in';
  var imagePaths = props.imagePaths || ((0, lodash_1.includes)(['small', 'default', 'smallName', 'card'], variant) ? exports.EntityValueImagePathsSmall : exports.EntityValueImagePathsDefault);
  var imageSize = props.imageSize || exports.EntityValueImageSizes[variant];
  var imageSpacing = props.imageSpacing || exports.EntityValueImageSpacing[variant];
  var showLabel = props.showLabel === undefined ? !(0, lodash_1.includes)(["name", "smallName", "title"], variant) : props.showLabel;
  var defaultName = (0, lodash_1.get)(entity, defn.valueNamePath);
  var dotSize = menuButtonProps.dotSize;
  var buttonUnitPad = dotSize <= 6 ? 1 : 2;
  var hasSubtitle = !!props.subtitle;
  var t = (0, use_lang_1.useLang)();
  var image;
  // don't waste unnecessary checks
  if (defn && defn.valueImageStyle !== 'bubble') {
    image = (0, coalesce_1.coalesce)(entity, imagePaths);
  }
  var name = props.name === '' ? '' : props.name || defaultName;
  return react_1.default.createElement(My.Container, {
    title: props.title || name,
    onClick: onClick,
    variant: variant,
    className: cls.name(className)
  }, showImage && (defn.valueImageStyle === 'color' ? react_1.default.createElement(My.ColorBubble, {
    color: (0, lodash_1.get)(entity, 'value'),
    size: imageSize
  }) : defn.valueImageStyle === 'bubble' || !image || alwaysShowIcon ? react_1.default.createElement(My.Image, {
    imagePaths: imagePaths,
    inset: imageInset,
    imageStyle: imageStyle,
    alwaysShowIcon: alwaysShowIcon,
    size: imageSize,
    entity: entity
  }) : react_1.default.createElement(My.BannerImage, {
    zoomable: useImageZoom,
    _height: imageSize,
    entity: image
  })), react_1.default.createElement(My.LabelAndName, {
    imageSpacing: imageSpacing,
    variant: variant
  }, showLabel && react_1.default.createElement(My.Label, {
    showNameFirst: showNameFirst,
    className: cls.sub('label'),
    hasName: !!name,
    dotSize: 6,
    space: 0.75,
    menu: showMenu && react_1.default.createElement(entity_menu_1.EntityMenu, {
      sourceEntity: entity,
      entity: menuEntity || entity
    }),
    variant: variant,
    badge: showBadge ? badge : ''
  }, t(label || entity.typeLabel || entity._label || defn.label)), showName && react_1.default.createElement(My.Name, {
    _wrap: wrap,
    className: cls.sub('name'),
    variant: variant
  }, highlight ? react_1.default.createElement(highlighter_1.Highlighter, {
    searchWords: [highlight],
    textToHighlight: name
  }) : name), hasSubtitle && react_1.default.createElement(My.Subtitle, {
    variant: variant,
    className: cls.sub('subtitle')
  }, subtitle)));
};
exports.EntityValue = EntityValue;
exports.EntityValue.cls = cls;
exports.EntityValue.defaultProps = exports.EntityValueDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26;